var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListTwoByTwo = function SvgListTwoByTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3 5.25A2.25 2.25 0 0 1 5.25 3h3.375a2.25 2.25 0 0 1 2.25 2.25v3.375a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 8.625zM13.125 5.25A2.25 2.25 0 0 1 15.375 3h3.375A2.25 2.25 0 0 1 21 5.25v3.375a2.25 2.25 0 0 1-2.25 2.25h-3.375a2.25 2.25 0 0 1-2.25-2.25zM3 15.375a2.25 2.25 0 0 1 2.25-2.25h3.375a2.25 2.25 0 0 1 2.25 2.25v3.375A2.25 2.25 0 0 1 8.625 21H5.25A2.25 2.25 0 0 1 3 18.75zM13.125 15.375a2.25 2.25 0 0 1 2.25-2.25h3.375a2.25 2.25 0 0 1 2.25 2.25v3.375A2.25 2.25 0 0 1 18.75 21h-3.375a2.25 2.25 0 0 1-2.25-2.25z"
  })));
};
export default SvgListTwoByTwo;